import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { RouterOutlet, ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LayoutNavbarComponent, NavbarMode } from '../../common/navbar/navbar.component';
import { LayoutFooterComponent } from '../../common/footer/footer.component';

@Component({
  selector: 'layout-landing',
  standalone: true,
  imports: [RouterOutlet, LayoutNavbarComponent, LayoutFooterComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './landing.component.html',
})
export class LayoutLandingComponent implements OnInit {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  navbarMode: NavbarMode = 'light';

  ngOnInit(): void {
    this.updateNavbarMode();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.updateNavbarMode();
        this.cdr.markForCheck();
      });
  }

  private updateNavbarMode(): void {
    let route = this.activatedRoute;
    while (route.firstChild) {
      route = route.firstChild;
    }
    const mode = route.snapshot.data['navbar']?.mode;
    this.navbarMode = mode === 'dark' ? 'dark' : 'light';
  }
}
